import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const getReasons = createAsyncThunk<any, void>('getReasons', async () => {
  try {
    const response = await api.get('temp-closed/reasons');
    return response.data.data;
  } catch (e: any) {
    console.warn(e);
  }
});

export const setClosed = createAsyncThunk<any, any>(
  'setClosed',
  async ({vendorId, reasonId, closedUntil}: any) => {
    try {
      const form = new FormData();
      form.append('closeUntil', closedUntil);
      const response = await api.post(
        `temp-closed/close?vendorId=${vendorId}&reasonId=${reasonId}`,
        form
      );
      return response.data.meta;
    } catch (e: any) {
      console.warn(e);
    }
  }
);

export const setOpenVendor = createAsyncThunk<any, any>('setOpenVendor', async (vendorId = 0) => {
  const response = await api.post(`temp-closed/open?vendorId=${vendorId}`);
  return response.data.meta.message;
});

export const getVendorSheetUrl = createAsyncThunk<any, any>(
  'getVendorSheetUrl',
  async (data, thunkApi) => {
    try {
      const response = await api.get(`/vendor-management/sheet-url?vendor_id=${data.vendor_id}`, {
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getVendorGrade = createAsyncThunk<any, any>(
  'getVendorGrade',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`/vendor-management/grade`, {
        params,
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);
